import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CFormSwitch
} from '@coreui/react-pro'

const FormSwitchInput = ({
  id,
  colSize,
  className,
  inputLabel,
  label,
  value,
  handleSwitch,
  feedbackInvalid,
  invalid,
  disabled
}) => {
  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
      )}
      <CFormSwitch
        id={id}
        label={label ? label : value?.toString()?.toLowerCase() === 'true' ? 'Yes' : 'No'}
        valid={value}
        defaultChecked={value}
        onChange={(e) => handleSwitch(e)}
        feedbackInvalid={feedbackInvalid}
        invalid={invalid}
        disabled={disabled}
        checked={value}
      />
    </CCol>
  )
}

export default FormSwitchInput